export const defaultBenchmarks = {
  'Bita Global Risk Model': 'iShares MSCI World ETF',
  'Bita US Risk Model': 'iShares Core S&P 500 ETF',
  'Bita Europe Risk Model': 'iShares Core EURO STOXX 50 UCITS ETF',
};
